import { ITableHeaderProps } from '../../table.interfaces';
import { StyledHeader, StyledTableHead } from './TableHeader.styles';
import { MuiTableRow } from '../../../base-components';
import HeaderCell from '../../Cells/HeaderCell';
import { allCells } from '../../Cells/cells.consts';
import { CellType } from '../../table.consts';

const TableHeader = (props: ITableHeaderProps) => {
    const { structure, tableState, onSelectAllRows } = props;
    const { cells, rowSelection } = structure;
    const { selectedRows, isLoading } = tableState;
    const CheckboxCell = allCells[CellType.Checkbox];
    const headerCheckboxSelected =
        Object.keys(selectedRows).length === tableState.currentEntitiesCount;
    const headerCheckboxIndeterminate =
        Object.keys(selectedRows).length > 0 &&
        Object.keys(selectedRows).length !== tableState.currentEntitiesCount;

    return (
        <StyledTableHead>
            <MuiTableRow>
                {rowSelection && (
                    <CheckboxCell
                        onSelectionChange={() => onSelectAllRows()}
                        alignment={'left'}
                        isItemSelected={!isLoading && headerCheckboxSelected}
                        indeterminate={
                            !isLoading && headerCheckboxIndeterminate
                        }
                        isHeaderCell
                        disabled={isLoading}
                    />
                )}
                {cells.map((cell) => {
                    return (
                        <StyledHeader
                            key={`${cell.headerTitle}-${cell.columnIndex}`}
                            columnIndex={cell.columnIndex}
                            stickyPosition={''}
                        >
                            <HeaderCell cell={cell} />
                        </StyledHeader>
                    );
                })}
            </MuiTableRow>
        </StyledTableHead>
    );
};

export default TableHeader;
